<template>
    <div class="record-container">
        <div class="record-content">
            <div class="header">
                <span style="color: #8F8F8F; margin-right: 4px;">当前位置: </span>
            <el-breadcrumb separator-class="el-icon-arrow-right">
                <el-breadcrumb-item>
                    <span class="color-blue" @click="goBackThree">上课记录</span>
                </el-breadcrumb-item>
                <el-breadcrumb-item>
                    <span class="color-blue" @click="goBack">{{courseName}}</span>
                </el-breadcrumb-item>
                <el-breadcrumb-item><span style="color: #8F8F8F;">考勤</span></el-breadcrumb-item>
            </el-breadcrumb>
            </div>
           <div class="title" ><p class="label_title">考勤记录</p> <el-button class="button" @click="goBack">返回</el-button></div>
            <el-table :data="recordsList"  style="width: 100%; flex: 1; margin-top: 20px" height="1%"  size="medium" :header-cell-style="headStyle" :cell-style="cellStyle">
                <el-table-column prop="id" label="序号"></el-table-column>
                <el-table-column prop="s_name" label="姓名"></el-table-column>
                <el-table-column label="上课时长">
                    <template slot-scope="scope">
                        <span>{{ scope.row.duration }}</span>
                    </template>
                </el-table-column>
                <el-table-column prop="begin_time" label="进入课程时间"></el-table-column>
            </el-table>
            <el-pagination class="pages-center" background
                           :current-page.sync="recordsPages.currentPageNum"
                           :page-size="recordsPages.eachPageNum"
                           :total="recordsPages.total"
                           layout="prev, pager, next"
                           @current-change="recordCurrentChange">
            </el-pagination>
        </div>
    </div>
</template>

<script>
    export default {
        data() {
            return {
                recordId: Number(this.$route.query.recordId) || '',
                courseName: this.$route.query.courseName || '',
                recordsList: [],
                recordsPages: {
                    currentPageNum: 1,
                    eachPageNum: 10,
                    total: 0,
                },
            }
        },
        mounted() {
            this.getRecordsList();
        },
        methods: {
            headStyle() {
            return 'background: #FAFAFA; fontWeight: 500; font-family: PingFang SC, PingFang SC; padding-left: 24px; color:#3E3E3E; height: 42px;'
        },
        cellStyle() {
            return 'padding-left: 24px; height: 60px; color: #333;'
        },
        getRecordsList() {
                let params = {
                    course_record_id: this.recordId,
                    page: this.recordsPages.currentPageNum,
                    limit: this.recordsPages.eachPageNum,
                }
                this.$shttp.axiosGetBy(this.$api.showSignInList, params, (res) => {
                    if (res.code === 200) {
                        this.recordsList = res.data.data
                        this.recordsPages.total = res.data.total
                    } else {
                        this.$message.warning(res.msg)
                    }
                }, (err) => {
                    console.log(err)
                })
            },
        recordCurrentChange(val) {
                this.recordsPages.currentPageNum = val;
                this.getRecordsList();
            },
            goBackThree(){
                this.$router.push('/qualityCourse/classRecord')
            },
        goBack() {
                this.$router.go(-1)
            },
            getTime(row){
                if(row.begin_time && row.end_time){
                    const timestamp1 = new Date(row.begin_time).getTime();
                    const timestamp2 = new Date(row.end_time).getTime();
                    const diffInSeconds = Math.abs((timestamp2 - timestamp1) / 1000);

                    // 转换为分钟
                    let diffInMinutes = Math.floor(diffInSeconds / 60);

                    // 根据规则调整不足一分钟但超过30秒的情况
                    if (diffInSeconds % 60 > 30) {
                        diffInMinutes += 1;
                    }
                    return diffInMinutes

                }else{
                    return "暂无数据"
                }

            }
        }
    }
</script>

<style scoped lang="scss">
    .record-container {
        height: calc(100% - 40px);
        background: #ffffff;
        padding: 20px 0;
        .record-content {
            height: 100%;
            display: flex;
            flex-direction: column;
            width: 1200px;
            margin: 0 auto;
            .header{
                display: flex;
                align-items: center;
            }
            .title{
                display: flex;
                justify-content: space-between;
                align-items: center;
                .button{
                    width: 96px;
                    height: 36px;
                    background: #006EFF;
                    border-radius: 4px 4px 4px 4px;
                    display: flex;
                    justify-content: center;
                    align-items: center;
                    color: #ffffff;
                }
                .label_title {
            position: relative;
            // margin: 20px 0;
            padding-left: 20px;
            font-family: PingFang SC, PingFang SC;
            font-weight: 400;
            font-size: 24px;
            color: #000000;
         
            // height: 20px;


            /* 为了给竖条留出空间 */
            &::before {
                content: '';
                position: absolute;
                left: 0;
                top: 0;
                width: 4px;
                /* 竖条的宽度 */
                height: 100%;
                /* 竖条的高度，与内容区域高度一致 */
                background-color: #409EFF;
                border-radius: 2px;
                /* 竖条的颜色 */
            }

        }

            }
        }
    }
    ::v-deep .el-breadcrumb__inner {
        color: #8F8F8F;
    }
</style>